import { cropService } from "../services/crops";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { clearAllTables } from "../utils/ui_utils";
import { hideMenu } from "../shared.js";

export class CropController {
  constructor() {
    this.type = "crop";
    this.cropNav = document.querySelector(".crop_nav");
    this.cropTableWindow = document.querySelector(".crop_table_window");
    this.updateWindow = document.querySelector(".update-crop-window");
    this.form = document.querySelector(".upload-crop");
    this.btnModal = document.querySelector(".table_modal-crop");
    this.table = null; // Tabulator instance
  }

  async init(currBtn, currAcc) {
    this.updateUI(currBtn);
    this.currentUser = currAcc;

    if (currAcc.status === "admin") {
      await this.initAdminView(currAcc);
    } else if (currAcc.status === "std") {
      await this.initStandardView();
    }
  }

  async initAdminView(currAcc) {
    // Get crops from Supabase
    const result = await cropService.listCrops();
    if (!result.success) {
      console.error("Failed to load crops:", result.error);
      return;
    }

    // Setup the data table
    this.setupDataTable(result.data, true);
  }

  async initStandardView() {
    const result = await cropService.listCrops();
    if (!result.success) {
      console.error("Failed to load crops:", result.error);
      return;
    }

    // Setup the data table (read-only)
    this.setupDataTable(result.data, false);
  }

  setupDataTable(data, isAdmin = false) {
    console.log("Setting up data table with data:", data);

    // Clear existing table and add Bootstrap container
    this.cropTableWindow.innerHTML = `
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="card border-0 ">
              <div class="card-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; padding: 1.5rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded-circle p-2 me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                      <img src="/icons/menu-crop1.jpg" alt="Crop Icon" style="width: 35px; height: 35px; border-radius: 15px; object-fit: cover;">
                    </div>
                    <div>
                      <h5 class="card-title mb-0 text-white fw-bold">Gestione Colture</h5>
                      <small class="text-white opacity-75"></small>
                    </div>
                  </div>
                  ${
                    isAdmin
                      ? `
                    <button class="btn btn-light add-crop-btn shadow-sm" style="padding: 0.75rem 1.5rem; border-radius: 10px; font-weight: 500;">
                      <i class="bi bi-plus-circle me-2" style="color: #59a370;"></i>
                      <span style="color: #59a370;">Aggiungi Coltura</span>
                    </button>
                  `
                      : ""
                  }
                </div>
              </div>
              <div class="card-body p-0" style="border-radius: 0 0 15px 15px; overflow: hidden;">
                <div id="crops-table" style="width: 100%; min-height: 400px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add event listener for the new add button
    if (isAdmin) {
      const addBtn = this.cropTableWindow.querySelector(".add-crop-btn");
      if (addBtn) {
        addBtn.addEventListener("click", () => this.handleAddCrop());
      }
    }

    // Add custom styles first
    this.addCustomStyles();

    // Define columns based on user role
    const columns = [
      // {
      //   title: "ID",
      //   field: "cropId",
      //   sorter: "string",
      //   width: 100,
      //   headerFilter: "input",
      // },
      {
        title: "Coltura",
        field: "crop",
        sorter: "string",
        width: 200,
        headerFilter: "input",
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-info text-white mb-1">N</span><span>Azoto</span></div>',
        field: "countN",
        sorter: "number",
        width: 120,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-warning text-dark mb-1">P2O5</span><span>Fosforo</span></div>',
        field: "countP2O5",
        sorter: "number",
        width: 130,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-success text-white mb-1">K2O</span><span>Potassio</span></div>',
        field: "countK2O",
        sorter: "number",
        width: 130,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-primary text-white mb-1">CaO</span><span>Calcio</span></div>',
        field: "countCaO",
        sorter: "number",
        width: 120,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-secondary text-white mb-1">MgO</span><span>Magnesio</span></div>',
        field: "countMgO",
        sorter: "number",
        width: 140,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-dark text-white mb-1">SO3</span><span>Zolfo</span></div>',
        field: "countSO3",
        sorter: "number",
        width: 120,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
    ];

    // Add action buttons for admin users
    if (isAdmin) {
      columns.push({
        title: "Azioni",
        field: "actions",
        width: 120,
        formatter: () => {
          return `
            <div class="btn-group" role="group">
              <button class="btn btn-outline-primary btn-sm btn-edit" title="Modifica">
                <i class="bi bi-pencil" style="pointer-events: none;"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm btn-delete" title="Elimina">
                <i class="bi bi-trash" style="pointer-events: none;"></i>
              </button>
            </div>
          `;
        },
        cellClick: (e, cell) => {
          e.stopPropagation();
          const target = e.target.closest("button");
          if (!target) return;

          const rowData = cell.getRow().getData();

          if (target.classList.contains("btn-edit")) {
            this.handleUpdateCrop(rowData);
          } else if (target.classList.contains("btn-delete")) {
            this.handleDeleteCrop(rowData);
          }
        },
      });
    }

    console.log("Creating Tabulator with columns:", columns);

    // Wait a bit to ensure DOM is ready
    setTimeout(() => {
      try {
        // Initialize Tabulator
        this.table = new Tabulator("#crops-table", {
          data: data,
          columns: columns,
          layout: "fitColumns",
          responsiveLayout: "hide",
          pagination: "local",
          paginationSize: 15,
          paginationSizeSelector: [10, 15, 25, 50],
          movableColumns: true,
          resizableRows: true,
          tooltips: true,
          tooltipsHeader: true,
          initialSort: [{ column: "cropId", dir: "asc" }],
          placeholder: "Nessuna coltura trovata",
          langs: {
            it: {
              pagination: {
                page_size: "Righe per pagina",
                page_title: "Mostra pagina",
                first: "Prima",
                first_title: "Prima pagina",
                last: "Ultima",
                last_title: "Ultima pagina",
                prev: "Precedente",
                prev_title: "Pagina precedente",
                next: "Successiva",
                next_title: "Pagina successiva",
                all: "Tutte",
                counter: {
                  showing: "Mostrando",
                  of: "di",
                  rows: "righe",
                },
              },
              headerFilters: {
                default: "Filtra colonna...",
                columns: {
                  cropId: "Filtra per ID...",
                  crop: "Filtra per coltura...",
                },
              },
            },
          },
          locale: "it",
          columnDefaults: {
            tooltip: true,
          },
        });

        console.log("Tabulator created successfully:", this.table);
      } catch (error) {
        console.error("Error creating Tabulator:", error);
        // Fallback to simple table
        this.createFallbackTable(data, columns);
      }
    }, 100);
  }

  createFallbackTable(data, columns) {
    console.log("Creating fallback table");

    let tableHTML = `
      <div style="border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background: white;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead style="background-color: #f8fafc;">
            <tr>
    `;

    columns.forEach((col) => {
      tableHTML += `<th style="padding: 12px 8px; text-align: left; font-weight: 600; border-bottom: 2px solid #e5e7eb;">${col.title}</th>`;
    });

    tableHTML += `
            </tr>
          </thead>
          <tbody>
    `;

    data.forEach((row, index) => {
      const bgColor = index % 2 === 0 ? "#ffffff" : "#f9fafb";
      tableHTML += `<tr style="background-color: ${bgColor};">`;

      columns.forEach((col) => {
        if (col.field === "actions") {
          tableHTML += `
            <td style="padding: 8px; border-bottom: 1px solid #f3f4f6; text-align: center;">
              <button onclick="window.cropController.handleUpdateCrop(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #3b82f6; cursor: pointer; margin-right: 8px;">
                ✏️
              </button>
              <button onclick="window.cropController.handleDeleteCrop(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #ef4444; cursor: pointer;">
                🗑️
              </button>
            </td>
          `;
        } else {
          let value = row[col.field] || "";
          if (col.formatter && typeof value === "number") {
            value = parseFloat(value).toFixed(2);
          }
          tableHTML += `<td style="padding: 8px; border-bottom: 1px solid #f3f4f6;">${value}</td>`;
        }
      });

      tableHTML += `</tr>`;
    });

    tableHTML += `
          </tbody>
        </table>
      </div>
    `;

    this.cropTableWindow.innerHTML = tableHTML;

    // Make controller available globally for fallback buttons
    window.cropController = this;
  }

  addCustomStyles() {
    if (document.getElementById("crop-table-styles")) return;

    const style = document.createElement("style");
    style.id = "crop-table-styles";
    style.textContent = `
      /* Tabulator base styling */
      .tabulator {
        border: none !important;
        border-radius: 0 !important;
        font-family: 'Poppins', sans-serif !important;
        font-size: 14px !important;
        background-color: white !important;
        overflow: hidden !important;
      }
      
      /* Header styling */
      .tabulator .tabulator-header {
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        border-bottom: 2px solid #59a370 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col {
        background: transparent !important;
        border-right: 1px solid #e5e7eb !important;
        padding: 15px 12px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
        padding: 0 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-title {
        font-weight: 600 !important;
        color: #59a370 !important;
        font-size: 13px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover .tabulator-col-title {
        color: white !important;
      }
      
      /* Row styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row {
        border-bottom: 1px solid #f1f5f9 !important;
        min-height: 50px !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row:hover {
        background: linear-gradient(135deg, #f0f9f4 0%, #ecfdf5 100%) !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.1) !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-even {
        background-color: #ffffff !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-odd {
        background-color: #fafbfc !important;
      }
      
      /* Cell styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
        border-right: 1px solid #f3f4f6 !important;
        padding: 12px !important;
        vertical-align: middle !important;
        font-weight: 500 !important;
      }
      
      /* Number cells styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="count"] {
        text-align: center !important;
        font-family: 'Monaco', 'Consolas', monospace !important;
        background-color: #f8fafc !important;
        color: #59a370 !important;
        font-weight: 600 !important;
      }
      
      /* Filter styling */
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
        border: 2px solid #e5e7eb !important;
        border-radius: 8px !important;
        padding: 6px 12px !important;
        font-size: 12px !important;
        width: 100% !important;
        box-sizing: border-box !important;
        transition: all 0.3s ease !important;
        font-family: 'Poppins', sans-serif !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input:focus {
        outline: none !important;
        border-color: #59a370 !important;
        box-shadow: 0 0 0 3px rgba(89, 163, 112, 0.1) !important;
        background-color: #f8fafc !important;
      }
      
      /* Pagination styling */
      .tabulator .tabulator-footer {
        border-top: 2px solid #e5e7eb !important;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        padding: 15px 20px !important;
        border-radius: 0 0 15px 15px !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page {
        background-color: white !important;
        border: 2px solid #e5e7eb !important;
        color: #59a370 !important;
        margin: 0 3px !important;
        padding: 8px 12px !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page.active {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
        color: white !important;
        border-color: #59a370 !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.2) !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page:hover:not(.active) {
        background-color: #f0f9f4 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      /* Bootstrap button group styling for actions */
      .btn-group .btn {
        margin: 0 !important;
        border-radius: 6px !important;
        transition: all 0.2s ease !important;
      }
      
      .btn-group .btn-outline-primary {
        border-color: #59a370 !important;
        color: #59a370 !important;
      }
      
      .btn-group .btn-outline-primary:hover {
        background-color: #59a370 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      .btn-group .btn-outline-danger:hover {
        transform: translateY(-1px) !important;
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .tabulator {
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
          padding: 8px 6px !important;
        }
        
        .btn-group .btn {
          padding: 4px 8px !important;
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-header .tabulator-col {
          padding: 10px 8px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  handleAddCrop() {
    console.log("Adding new crop");

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup()}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadCrop__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitNewCrop();
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleUpdateCrop(cropData) {
    console.log("Updating crop:", cropData);

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup(true, cropData)}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadCrop__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitUpdateCrop(cropData.cropId);
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleDeleteCrop(cropData) {
    console.log("Deleting crop:", cropData);

    // Create Bootstrap confirmation modal
    const confirmationHtml = `
      <div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" id="deleteConfirmModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">
                <i class="bi bi-exclamation-triangle me-2"></i>Conferma Eliminazione
              </h5>
            </div>
            <div class="modal-body">
              <p class="mb-3">Sei sicuro di voler eliminare la coltura:</p>
              <div class="alert alert-warning">
                <strong>
                  <img src="/icons/menu-crop1.jpg" alt="Crop Icon" style="width: 20px; height: 20px;
                  border-radius:10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">
                  ${cropData.crop}
                </strong>
              </div>
              <p class="text-muted small">Questa azione non può essere annullata.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="cancelDelete">
                <i class="bi bi-x-circle me-1"></i>Annulla
              </button>
              <button type="button" class="btn btn-danger" id="confirmDelete">
                <i class="bi bi-trash me-1"></i>Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = confirmationHtml;
    document.body.appendChild(modalContainer);

    const modal = modalContainer.querySelector("#deleteConfirmModal");
    const confirmBtn = modal.querySelector("#confirmDelete");
    const cancelBtn = modal.querySelector("#cancelDelete");

    // Handle confirmation
    confirmBtn.addEventListener("click", async () => {
      const result = await cropService.deleteCrop(cropData.cropId);
      if (result.success) {
        await this.refreshTable();
        this.showNotification("Coltura eliminata con successo", "success");
      } else {
        console.error("Failed to delete crop:", result.error);
        this.showNotification(
          "Errore nell'eliminazione della coltura",
          "error"
        );
      }
      document.body.removeChild(modalContainer);
    });

    // Handle cancellation
    cancelBtn.addEventListener("click", () => {
      document.body.removeChild(modalContainer);
    });
  }

  async submitNewCrop() {
    const cropData = this.getCropDataFromForm();

    if (!this.validateCropData(cropData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    // Check for duplicate crop name
    const checkResult = await cropService.existsCropByName(cropData.crop);
    if (!checkResult.success) {
      this.showNotification("Errore nel controllo del nome coltura.", "error");
      return;
    }
    if (checkResult.exists) {
      this.showNotification("Esiste già una coltura con questo nome.", "error");
      return;
    }

    console.log("Creating crop:", cropData);
    const result = await cropService.createCrop(cropData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Coltura creata con successo", "success");
    } else {
      console.error("Failed to create crop:", result.error);
      this.showNotification("Errore nella creazione della coltura", "error");
    }
  }

  async submitUpdateCrop(cropId) {
    const cropData = this.getCropDataFromForm();

    if (!this.validateCropData(cropData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    console.log("Updating crop:", cropId, cropData);
    const result = await cropService.updateCrop(cropId, cropData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Coltura aggiornata con successo", "success");
    } else {
      console.error("Failed to update crop:", result.error);
      this.showNotification("Errore nell'aggiornamento della coltura", "error");
    }
  }

  getCropDataFromForm() {
    return {
      crop: this.form.querySelector('[name="crop"]').value.trim(),
      countN: Number(this.form.querySelector('[name="countN"]').value) || 0,
      countP2O5:
        Number(this.form.querySelector('[name="countP2O5"]').value) || 0,
      countK2O: Number(this.form.querySelector('[name="countK2O"]').value) || 0,
      countCaO: Number(this.form.querySelector('[name="countCaO"]').value) || 0,
      countMgO: Number(this.form.querySelector('[name="countMgO"]').value) || 0,
      countSO3: Number(this.form.querySelector('[name="countSO3"]').value) || 0,
    };
  }

  validateCropData(cropData) {
    return cropData.crop && cropData.crop.length > 0;
  }

  closeModal() {
    this.updateWindow.classList.add("hidden");
    this.updateWindow.classList.remove("modal", "fade", "show");
    this.updateWindow.style.display = "none";
    this.updateWindow.style.backgroundColor = "";
    this.form.innerHTML = "";
  }

  async refreshTable() {
    if (!this.table) return;

    const result = await cropService.listCrops();
    if (result.success) {
      this.table.setData(result.data);
    }
  }

  showNotification(message, type = "info") {
    // Create Bootstrap toast notification
    const toastId = `toast-${Date.now()}`;
    const iconClass =
      type === "success"
        ? "bi-check-circle-fill"
        : type === "error"
        ? "bi-exclamation-triangle-fill"
        : "bi-info-circle-fill";

    // Use our app's green theme colors
    const bgClass =
      type === "success"
        ? "text-white"
        : type === "error"
        ? "text-white"
        : "text-white";

    const bgStyle =
      type === "success"
        ? "background: linear-gradient(135deg, #059669 0%, #047857 100%);"
        : type === "error"
        ? "background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);"
        : "background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);";

    const toastHtml = `
      <div class="toast align-items-center ${bgClass} border-0 shadow-lg" role="alert" aria-live="assertive" aria-atomic="true" id="${toastId}" style="${bgStyle} border-radius: 12px;">
        <div class="d-flex">
          <div class="toast-body py-3 px-4" style="font-weight: 500; font-size: 14px;">
            <i class="${iconClass} me-2" style="font-size: 16px;"></i>${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-3 my-auto" data-bs-dismiss="toast" aria-label="Close" style="filter: brightness(0) invert(1);"></button>
        </div>
      </div>
    `;

    // Create or get toast container
    let toastContainer = document.querySelector(
      ".toast-container.fertify-notifications"
    );
    if (!toastContainer) {
      toastContainer = document.createElement("div");
      toastContainer.className =
        "toast-container fertify-notifications position-fixed top-0 end-0 p-3";
      toastContainer.style.zIndex = "9999";
      toastContainer.style.marginTop = "80px"; // Account for navbar height
      document.body.appendChild(toastContainer);
    }

    // Add toast to container
    const toastElement = document.createElement("div");
    toastElement.innerHTML = toastHtml;
    toastContainer.appendChild(toastElement.firstElementChild);

    // Initialize and show Bootstrap toast
    const toast = new bootstrap.Toast(document.getElementById(toastId), {
      autohide: true,
      delay: 5000,
    });

    toast.show();

    // Add custom animation styles
    const toastEl = document.getElementById(toastId);
    toastEl.style.transform = "translateX(100%)";
    toastEl.style.transition = "transform 0.3s ease-out";

    // Animate in
    setTimeout(() => {
      toastEl.style.transform = "translateX(0)";
    }, 10);

    // Remove toast element after it's hidden
    toastEl.addEventListener("hidden.bs.toast", () => {
      toastEl.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toastEl && toastEl.parentNode) {
          toastEl.remove();
        }
      }, 300);
    });
  }

  updateUI(currBtn) {
    // Clear active states and set current button as active
    document.querySelectorAll(".menu__btn").forEach((btn) => {
      btn.classList.remove("menu__btn--active");
    });
    currBtn.classList.add("menu__btn--active");

    hideMenu();
    // Clear all table windows
    clearAllTables(false);
  }

  // Create Bootstrap-styled form markup
  createBootstrapFormMarkup(isEdit = false, cropData = null) {
    const title = isEdit ? "Modifica Coltura" : "Aggiungi Coltura";
    const buttonText = isEdit ? "Aggiorna" : "Salva";

    return `
      <div class="modal-header border-bottom-0 pb-3 mb-4" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); margin: -2rem -2rem 2rem -2rem; padding: 2rem; border-radius: 15px 15px 0 0;">
        <div class="d-flex align-items-center text-white">
          <div class="bg-white rounded-circle p-2 me-3" style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
            <img src="/icons/menu-crop1.jpg" alt="Crop Icon" style="width: 40px; height: 40px; border-radius:20px;object-fit: cover;">
          </div>
          <div>
            <h4 class="modal-title mb-0 fw-bold">${title}</h4>
            <small class="opacity-75"></small>
          </div>
        </div>
      </div>
      
      <form class="needs-validation" novalidate>
        <div class="row g-4">
          <!-- Crop Name -->
          <div class="col-12 mb-3">
            <label for="crop" class="form-label fw-semibold fs-5" style="color: #59a370;">
              <i class="bi bi-tag me-2"></i>Nome Coltura
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="crop" 
              name="crop" 
              placeholder="Inserisci il nome della coltura"
              value="${cropData?.crop || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 1rem; font-size: 1.1rem;"
              required
            >
            <div class="invalid-feedback">
              Il nome della coltura è obbligatorio.
            </div>
          </div>

          <!-- Nutrient Values Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-graph-up me-2"></i>Valori Nutrizionali (kg/ha)
              </h6>
              <small class="text-muted">Inserisci i valori per ogni titolo</small>
            </div>
          </div>

          <!-- Nutrient Values Row 1 -->
          <div class="col-lg-6">
            <label for="countN" class="form-label fw-semibold">
              <span class="badge bg-info me-2">N</span>Azoto
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countN" 
                name="countN" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countN || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="countP2O5" class="form-label fw-semibold">
              <span class="badge bg-warning text-dark me-2">P2O5</span>Fosforo
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countP2O5" 
                name="countP2O5" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countP2O5 || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <!-- Nutrient Values Row 2 -->
          <div class="col-lg-6">
            <label for="countK2O" class="form-label fw-semibold">
              <span class="badge bg-success text-white me-2">K2O</span>Potassio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countK2O" 
                name="countK2O" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countK2O || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="countCaO" class="form-label fw-semibold">
              <span class="badge bg-primary text-white me-2">CaO</span>Calcio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countCaO" 
                name="countCaO" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countCaO || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <!-- Nutrient Values Row 3 -->
          <div class="col-lg-6">
            <label for="countMgO" class="form-label fw-semibold">
              <span class="badge bg-secondary text-white me-2">MgO</span>Magnesio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countMgO" 
                name="countMgO" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countMgO || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="countSO3" class="form-label fw-semibold">
              <span class="badge bg-dark text-white me-2">SO3</span>Zolfo
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="countSO3" 
                name="countSO3" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${cropData?.countSO3 || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="modal-footer border-top pt-4 mt-5 d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-outline-secondary btn-lg px-4" data-bs-dismiss="modal" style="border-radius: 10px;">
            <i class="bi bi-x-circle me-2"></i>Annulla
          </button>
          <button type="submit" class="btn btn-lg px-5 uploadCrop__btn" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; color: white; border-radius: 10px; font-weight: 500;">
            <i class="bi bi-check-circle me-2"></i>${buttonText}
          </button>
        </div>
      </form>
    `;
  }
}

// Create and export a singleton instance
export const cropController = new CropController();
